import "./style.css";

export const TextAreaSkeleton = ({ style }) => (
  <div className='text-area skeleton-loader' style={style}/>
);